<svelte:options accessors/>
<script>
    import {createEventDispatcher} from 'svelte';
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";

    export let margin;
    export let type;

    let dispatch = createEventDispatcher();

    function saveMargin() {
        dispatch('changemargin', {margin, type});
    }
</script>

<NauiInput label="MARGEN (%)" bind:value={margin}/>
<NauiButton caption="" mode="stroked" icon="pencil" on:click={saveMargin}/>
